export const FIELD_TYPE = {
  TEXT: "text",
  DATE: "date",
  NUMBER: "number",
  PASSWORD: "password",
};

export const VALUES = {
  EMPTY_STRING: "",
  EMPTY_ARRAY: [],
  EMPTY_OBJECT: {},
};

export const TAGS = {
  H3: "h3",
  H4: "h4",
  P: "p",
  DIV: "div",
  FORM: "form",
  LABEL: "label",
  INPUT: "input",
};

export const DISPLAY_NONE = {
  display: "none",
};
export const VISIBILITY_HIDDEN = {
  visibility: "hidden",
};
export const ATTRIBUTES = {
  CONTAINED: { variant: "contained" },
  OUTLINED: { variant: "outlined" },
  SUBMIT: { type: "submit" },
};

export const STEPPERNAME = ["Pick your Carriers and OTAs", "Choose Flight Attributes", "Schedule & Frequency"]
export const AirlineErrTxt = "Column 'Primary Airline' value is different from Bde panel";
export const GroupInShopErrTxt = "Market Group already exists for the selected Shops";
export const AirlineAlertTXT = "Airline code is different from the previous selection. Are you sure you want to change the airline code?"